import * as cartTypes from '../types/carttypes';

const initialState = {
    cart: [],
    cartTracker: new Map(),
    orderInfo: {}
};

export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        case cartTypes.ADD_TO_CART: {
            const { id } = action.payload;
            const cart = [...state.cart, action.payload];
            state.cartTracker.set(id, action.payload);
            return {
                ...state,
                cart
            };
        }
        case cartTypes.REMOVE_FROM_CART:  {
            const { id } = state.cart[action.payload];
            state.cartTracker.delete(id);
            const cart = [...state.cart];
            cart.splice(action.payload, 1);
            if (cart.length < 1) {
                state.orderInfo = {};
            }
            return {
                ...state,
                cart
            };
        }
        case cartTypes.UPDATE_CART_ORDER_INFO:
            return {
                ...state,
                orderInfo: action.payload
            };

        case cartTypes.EMPTY_CART:
            state.cartTracker.clear();
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
}